import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary'; // 1005h · 공명 SA-T441 — 맨 위 오류 경계(빈 화면 대신 대체 화면)
import VersionBanner from './components/VersionBanner'; // P2c 3걸음 — 새 화면 알림(규칙 바뀌기 前 새로 고침)
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary scope="app">
      <App />
      <VersionBanner />
    </ErrorBoundary>
  </React.StrictMode>
);
